import { useEffect, useState } from "react";
import api from "../constant/api";
import {
  Search,
  RotateCcw,
  Package,
  User,
  Phone,
  Calendar,
  X
} from "lucide-react";

import { AnimatePresence, motion } from "framer-motion";

export default function ProductReturn() {

  const [search, setSearch] =
    useState("");

  const [orders, setOrders] =
    useState([]);

  const [loading, setLoading] =
    useState(false);

  const [selectedOrder, setSelectedOrder] =
    useState(null);

  const [items, setItems] =
    useState([]);

  // MODAL
  const [showReturnModal, setShowReturnModal] =
    useState(false);

  const [returnItem, setReturnItem] =
    useState(null);

  const [returnQty, setReturnQty] =
    useState("");

  const [returnPcs, setReturnPcs] =
    useState("");

  // =========================
  // SEARCH ORDER
  // =========================

  const searchOrders = async () => {

    try {

      setLoading(true);

      const res = await api.get(
        `/Order/searchOrders?search=${search}`
      );

      setOrders(res.data.data || []);

    } catch (err) {

      console.log(err);

    } finally {

      setLoading(false);

    }

  };

  // =========================
  // GET ORDER ITEMS
  // =========================

  const getOrderItems = async (order) => {

    try {

      setSelectedOrder(order);

      const res = await api.get(
        `/Product/getReturnOrder/${order.order_id}`
      );

      setItems(res.data.data || []);

    } catch (err) {

      console.log(err);

    }

  };

  // =========================
  // OPEN RETURN MODAL
  // =========================

  const openReturnModal = (item) => {

    setReturnItem(item);

    setReturnQty("");

    setReturnPcs("");

    setShowReturnModal(true);

  };

  // =========================
  // RETURN PRODUCT
  // =========================

 // =========================
// RETURN PRODUCT
// =========================

const submitReturn = async () => {

  try {

    const qty =
      Number(returnQty || 0);

    const pcs =
      Number(returnPcs || 0);

    const pcsPerBox =
      Number(
        returnItem?.pcs_per_box || 1
      );

    // =========================
    // BALANCE VALUES
    // =========================

    const balanceQty =
      Number(returnItem?.qty || 0)
      -
      Number(returnItem?.return_qty || 0);

    const balancePcs =
      Number(returnItem?.pcs || 0)
      -
      Number(returnItem?.return_pcs || 0);

    // =========================
    // VALIDATION
    // =========================

    if (qty < 0 || pcs < 0) {

      return alert(
        "Invalid return values"
      );

    }

    if (qty === 0 && pcs === 0) {

      return alert(
        "Enter Qty or PCS"
      );

    }

    // =========================
    // CONVERT TO TOTAL PCS
    // =========================

    const returnTotalPcs =
      (qty * pcsPerBox) + pcs;

    const balanceTotalPcs =
      (balanceQty * pcsPerBox)
      +
      balancePcs;

    // =========================
    // CHECK EXCEED
    // =========================

    if (
      returnTotalPcs >
      balanceTotalPcs
    ) {

      return alert(
        `Only ${balanceQty} Box ${balancePcs} PCS available`
      );

    }

    // =========================
    // API
    // =========================

    const res = await api.post(
      "/Product/productReturn",
      {
        order_id:
          returnItem.order_id,

        order_item_id:
          returnItem.order_item_id,

        product_id:
          returnItem.product_id,

        return_qty: qty,

        return_pcs: pcs,

        pcs_per_box:
          pcsPerBox,

        reason:
          "Customer Return"
      }
    );

    alert(res.data.message);

    if (res.data.success) {

      setShowReturnModal(false);

      // REFRESH
      getOrderItems(selectedOrder);

    }

  } catch (err) {

    console.log(err);

    alert("Return Failed");

  }

};

  useEffect(() => {

    searchOrders();

  }, []);

  return (

    <div className="
      min-h-screen
      bg-gray-100
      p-3
      md:p-5
    ">

      {/* HEADER */}

      <div className="
        bg-gradient-to-r
        from-red-500
        to-red-600
        text-white
        rounded-3xl
        p-5
        shadow-lg
        mb-5
      ">

        <h1 className="
          text-2xl
          md:text-3xl
          font-bold
        ">
          Product Return
        </h1>

        <p className="text-sm opacity-90 mt-1">
          Manage customer product returns
        </p>

      </div>

      {/* SEARCH */}

      <div className="
        bg-white
        rounded-2xl
        p-3
        shadow
        flex
        gap-2
        mb-5
      ">

        <input
          type="text"
          placeholder="
            Search Order ID / Customer / Phone
          "
          value={search}
          onChange={(e)=>
            setSearch(e.target.value)
          }
          className="
            flex-1
            border
            rounded-xl
            p-3
            outline-none
          "
        />

        <button
          onClick={searchOrders}
          className="
            bg-blue-500
            hover:bg-blue-600
            text-white
            px-5
            rounded-xl
            flex
            items-center
            gap-2
          "
        >

          <Search size={18} />

        </button>

      </div>

      {/* ORDER LIST */}

      <div className="
        grid
        md:grid-cols-2
        gap-4
      ">

        {/* LEFT */}

        <div className="
          bg-white
          rounded-3xl
          shadow
          p-4
          max-h-[80vh]
          overflow-auto
        ">

          <h2 className="
            text-xl
            font-bold
            mb-4
          ">
            Orders
          </h2>

          {loading && (
            <p>Loading...</p>
          )}

          {!loading && orders.map((order) => (

            <div
              key={order.order_id}
              onClick={() =>
                getOrderItems(order)
              }
              className={`
                border
                rounded-2xl
                p-4
                mb-3
                cursor-pointer
                transition
                hover:shadow-lg
                ${
                  selectedOrder?.order_id
                  === order.order_id
                    ? "border-red-500 bg-red-50"
                    : ""
                }
              `}
            >

              <div className="
                flex
                justify-between
                items-center
              ">

                <div>

                  <h3 className="
                    font-bold
                    text-lg
                  ">
                    Order #
                    {order.order_id}
                  </h3>

                  <div className="
                    text-sm
                    text-gray-500
                    mt-1
                  ">

                    <div className="
                      flex
                      items-center
                      gap-1
                    ">
                      <User size={14} />
                      {order.name}
                    </div>

                    <div className="
                      flex
                      items-center
                      gap-1
                    ">
                      <Phone size={14} />
                      {order.phone}
                    </div>

                  </div>

                </div>

                <div className="
                  text-right
                ">

                  <p className="
                    font-bold
                    text-green-600
                  ">
                    ₹{order.net_total}
                  </p>

                  <div className="
                    text-xs
                    text-gray-500
                    flex
                    items-center
                    gap-1
                    justify-end
                  ">
                    <Calendar size={12} />
                    {order.created_at}
                  </div>

                </div>

              </div>

            </div>

          ))}

        </div>

        {/* RIGHT */}

        <div className="
          bg-white
          rounded-3xl
          shadow
          p-4
          max-h-[80vh]
          overflow-auto
        ">

          <h2 className="
            text-xl
            font-bold
            mb-4
          ">
            Return Products
          </h2>

          {!selectedOrder && (

            <div className="
              text-center
              text-gray-400
              py-20
            ">

              <Package
                size={60}
                className="mx-auto mb-3"
              />

              <p>Select order</p>

            </div>

          )}

        {items.map((item) => {

  // =========================
  // PCS PER BOX
  // =========================

  const pcsPerBox =
    Number(item.pcs_per_box || 1);

  // =========================
  // SOLD VALUES
  // =========================

  const soldQty =
    Number(item.qty || 0);

  const soldPcs =
    Number(item.pcs || 0);

  // =========================
  // RETURNED VALUES
  // =========================

  const returnedQty =
    Number(item.return_qty || 0);

  const returnedPcs =
    Number(item.return_pcs || 0);

  // =========================
  // TOTAL PCS CONVERSION
  // =========================

  const soldTotalPcs =
    (soldQty * pcsPerBox) +
    soldPcs;

  const returnedTotalPcs =
    (returnedQty * pcsPerBox) +
    returnedPcs;

  // =========================
  // BALANCE
  // =========================

  const balanceTotalPcs =
    soldTotalPcs -
    returnedTotalPcs;

  // =========================
  // FINAL BALANCE
  // =========================

  const balanceQty =
    Math.floor(
      balanceTotalPcs / pcsPerBox
    );

  const balancePcs =
    Number(
      (
        balanceTotalPcs %
        pcsPerBox
      ).toFixed(2)
    );

  return (

    <div
      key={item.order_item_id}
      className="
        border
        rounded-2xl
        p-4
        mb-4
      "
    >

      {/* TOP */}

      <div className="
        flex
        justify-between
        gap-3
      ">

        <div>

          <h3 className="
            font-bold
            text-lg
          ">
            {item.product_name}
          </h3>

          <p className="
            text-sm
            text-gray-500
          ">
            Code:
            {item.product_code}
          </p>

        </div>

        <div className="
          text-right
        ">

          <p className="
            font-bold
            text-green-600
          ">
            ₹{item.price}
          </p>

        </div>

      </div>

      {/* QTY SECTION */}

      <div className="
        grid
        grid-cols-3
        gap-3
        mt-4
        text-center
      ">

        <div className="
          bg-blue-50
          rounded-xl
          p-3
        ">

          <p className="
            text-sm
            text-gray-500
          ">
            Sold Qty
          </p>

          <h3 className="
            font-bold
          ">
            {soldQty}
          </h3>

        </div>

        <div className="
          bg-red-50
          rounded-xl
          p-3
        ">

          <p className="
            text-sm
            text-gray-500
          ">
            Returned Qty
          </p>

          <h3 className="
            font-bold
          ">
            {returnedQty}
          </h3>

        </div>

        <div className="
          bg-green-50
          rounded-xl
          p-3
        ">

          <p className="
            text-sm
            text-gray-500
          ">
            Balance Qty
          </p>

          <h3 className="
            font-bold
          ">
            {balanceQty}
          </h3>

        </div>

      </div>

      {/* PCS SECTION */}

      <div className="
        grid
        grid-cols-3
        gap-3
        mt-3
        text-center
      ">

        <div className="
          bg-blue-50
          rounded-xl
          p-3
        ">

          <p className="
            text-sm
            text-gray-500
          ">
            Sold PCS
          </p>

          <h3 className="
            font-bold
          ">
            {soldPcs}
          </h3>

        </div>

        <div className="
          bg-red-50
          rounded-xl
          p-3
        ">

          <p className="
            text-sm
            text-gray-500
          ">
            Returned PCS
          </p>

          <h3 className="
            font-bold
          ">
            {returnedPcs}
          </h3>

        </div>

        <div className="
          bg-green-50
          rounded-xl
          p-3
        ">

          <p className="
            text-sm
            text-gray-500
          ">
            Balance PCS
          </p>

          <h3 className="
            font-bold
          ">
            {balancePcs}
          </h3>

        </div>

      </div>

      {/* BUTTON */}

      <button
        disabled={
          balanceTotalPcs <= 0
        }
        onClick={() =>
          openReturnModal(item)
        }
        className="
          mt-4
          w-full
          bg-red-500
          hover:bg-red-600
          disabled:bg-gray-300
          text-white
          py-3
          rounded-2xl
          font-bold
          flex
          items-center
          justify-center
          gap-2
        "
      >

        <RotateCcw size={18} />

        Return Product

      </button>

    </div>

  );

})}

        </div>

      </div>


{/* RETURN MODAL */}
{/* ========================= */}

<AnimatePresence>

  {showReturnModal && (() => {

    // =========================
    // PCS PER BOX
    // =========================

    const pcsPerBox =
      Number(returnItem?.pcs_per_box || 1);

    // =========================
    // SOLD
    // =========================

    const soldQty =
      Number(returnItem?.qty || 0);

    const soldPcs =
      Number(returnItem?.pcs || 0);

    // =========================
    // RETURNED
    // =========================

    const returnedQty =
      Number(returnItem?.return_qty || 0);

    const returnedPcs =
      Number(returnItem?.return_pcs || 0);

    // =========================
    // TOTAL PCS
    // =========================

    const soldTotalPcs =
      (soldQty * pcsPerBox) +
      soldPcs;

    const returnedTotalPcs =
      (returnedQty * pcsPerBox) +
      returnedPcs;

    // =========================
    // BALANCE
    // =========================

    const balanceTotalPcs =
      soldTotalPcs -
      returnedTotalPcs;

    const balanceQty =
      Math.floor(
        balanceTotalPcs / pcsPerBox
      );

    const balancePcs =
      Number(
        (
          balanceTotalPcs %
          pcsPerBox
        ).toFixed(2)
      );

    return (

      <motion.div
        className="
          fixed
          inset-0
          bg-black/60
          backdrop-blur-sm
          flex
          items-center
          justify-center
          z-[99999]
          p-3
        "
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
      >

        <motion.div
          initial={{
            scale: 0.8,
            y: 50
          }}
          animate={{
            scale: 1,
            y: 0
          }}
          exit={{
            scale: 0.8,
            y: 50
          }}
          transition={{
            duration: 0.25
          }}
          className="
            bg-white
            w-full
            max-w-md
            rounded-3xl
            shadow-2xl
            overflow-hidden
          "
        >

          {/* HEADER */}

          <div className="
            bg-gradient-to-r
            from-red-500
            to-red-400
            p-5
            text-white
            flex
            justify-between
            items-center
          ">

            <div>

              <h2 className="
                text-xl
                font-bold
              ">
                Return Product
              </h2>

              <p className="
                text-sm
                opacity-90
                mt-1
              ">
                {returnItem?.product_name}
              </p>

            </div>

            <button
              onClick={() =>
                setShowReturnModal(false)
              }
              className="
                p-2
                rounded-full
                hover:bg-white/20
              "
            >
              <X size={20} />
            </button>

          </div>

          {/* BODY */}

          <div className="
            p-5
            space-y-5
          ">

            {/* BALANCE DETAILS */}

            <div className="
              grid
              grid-cols-2
              gap-4
            ">

              <div className="
                bg-green-50
                border
                border-green-100
                p-4
                rounded-2xl
                text-center
              ">

                <p className="
                  text-xs
                  text-gray-500
                  mb-1
                ">
                  Balance Qty
                </p>

                <h3 className="
                  text-2xl
                  font-bold
                  text-green-700
                ">
                  {balanceQty}
                </h3>

              </div>

              <div className="
                bg-green-50
                border
                border-green-100
                p-4
                rounded-2xl
                text-center
              ">

                <p className="
                  text-xs
                  text-gray-500
                  mb-1
                ">
                  Balance PCS
                </p>

                <h3 className="
                  text-2xl
                  font-bold
                  text-green-700
                ">
                  {balancePcs}
                </h3>

              </div>

            </div>

            {/* PCS PER BOX */}

            <div className="
              bg-blue-50
              border
              border-blue-100
              rounded-2xl
              p-3
              text-center
            ">

              <p className="
                text-sm
                text-gray-600
              ">
                PCS Per Box :
                <span className="
                  font-bold
                  text-blue-700
                  ml-1
                ">
                  {pcsPerBox}
                </span>
              </p>

            </div>

            {/* RETURN QTY */}

<div>

  <label className="
    text-sm
    font-semibold
    text-gray-700
    block
    mb-2
  ">
    Return Qty
  </label>

  <input
    type="number"
    min="0"

    // =========================
    // DISABLE IF NO QTY
    // =========================

    disabled={balanceQty <= 0}

    value={returnQty}

    onChange={(e)=>
      setReturnQty(
        e.target.value
      )
    }

    className={`
      w-full
      border
      rounded-2xl
      px-4
      py-3
      outline-none
      ${
        balanceQty <= 0
          ? "bg-gray-100 cursor-not-allowed"
          : "border-gray-200 focus:border-red-400"
      }
    `}

    placeholder={
      balanceQty <= 0
        ? "No Qty Available"
        : "Enter Qty"
    }
  />

</div>

            {/* RETURN PCS */}

            <div>

              <label className="
                text-sm
                font-semibold
                text-gray-700
                block
                mb-2
              ">
                Return PCS
              </label>

              <input
                type="number"
                min="0"
                value={returnPcs}
                onChange={(e)=>
                  setReturnPcs(
                    e.target.value
                  )
                }
                className="
                  w-full
                  border
                  border-gray-200
                  rounded-2xl
                  px-4
                  py-3
                  outline-none
                  focus:border-red-400
                "
                placeholder="Enter PCS"
              />

            </div>

          </div>

          {/* FOOTER */}

          <div className="
            p-5
            border-t
            flex
            gap-3
          ">

            <button
              onClick={() =>
                setShowReturnModal(false)
              }
              className="
                flex-1
                border
                border-gray-300
                py-3
                rounded-2xl
                font-semibold
                hover:bg-gray-100
              "
            >
              Cancel
            </button>

            <button
              onClick={submitReturn}
              className="
                flex-1
                bg-red-500
                hover:bg-red-600
                text-white
                py-3
                rounded-2xl
                font-semibold
              "
            >
              Confirm Return
            </button>

          </div>

        </motion.div>

      </motion.div>

    );

  })()}

</AnimatePresence>

    </div>

  );

}